import { createReducer } from "@reduxjs/toolkit";
import Actions from "~app/constants/actions";
import ModelReducer from "~app/modules/model-reducer";

const initialState = {
    models: [],
    skip: null,
    limit: null,
    search: null,
    totalCount: null,
    count: null,
};

const showcasesReducer = createReducer(initialState, {
    [Actions.Showcases.Query]: ModelReducer.QueryModels(),
    [Actions.Showcases.Search]: ModelReducer.SearchModels(),
    [Actions.Showcases.Paginate]: ModelReducer.PaginateModels(),
    [Actions.Showcases.Update]: ModelReducer.UpdateModel(),
    [Actions.Showcases.Create]: ModelReducer.CreateModel(),
});

export default showcasesReducer;
